import { hasPermission } from '@/lib/permissions'
import type { MembershipScopes } from '@/types/api'
import { availableViews } from '@/features/variables/lib/scopes'
import type { FieldScopeType } from '../types'

/** `/fields?scope=tenant` | `?scope=location:01J…` */
export interface FieldsSearch {
  scope?: string
}

const SCOPE_RE = /^(location|display_group|display):[0-9A-Za-z]{1,64}$/

export function validateFieldsSearch(s: Record<string, unknown>): FieldsSearch {
  if (s.scope === 'tenant' || (typeof s.scope === 'string' && SCOPE_RE.test(s.scope))) return { scope: s.scope as string }
  return {}
}

export function parseFieldScope(value: string | undefined): { type: FieldScopeType; id: string | null } | null {
  if (!value) return null
  if (value === 'tenant') return { type: 'tenant', id: null }
  if (!SCOPE_RE.test(value)) return null
  const [type, id] = value.split(':') as [FieldScopeType, string]
  return { type, id }
}

export const FIELD_SCOPE_LABELS: Record<FieldScopeType, string> = { tenant: 'Organization', location: 'Location', display_group: 'Display group', display: 'Display' }

/**
 * Scope levels offered on the Fields page: the organization value only with `variables.manage`
 * (it's a tenant-wide grant), locations / groups / displays as for variables (restricted members:
 * their scopes and the displays inside them).
 */
export function fieldScopeTypes(permissions: readonly string[] | null | undefined, scopes: MembershipScopes | null | undefined): FieldScopeType[] {
  const views = availableViews(permissions, scopes)
  const out: FieldScopeType[] = []
  if (hasPermission(permissions, 'variables.manage')) out.push('tenant')
  for (const v of ['location', 'display_group', 'display'] as const) if (views.includes(v)) out.push(v)
  return out
}
